import { render, staticRenderFns } from "./NewGroupAddContact.vue?vue&type=template&id=35324cff&scoped=true&"
import script from "./NewGroupAddContact.vue?vue&type=script&lang=js&"
export * from "./NewGroupAddContact.vue?vue&type=script&lang=js&"
import style0 from "./NewGroupAddContact.vue?vue&type=style&index=0&id=35324cff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35324cff",
  null
  
)

export default component.exports